import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

function ProtectedRoute({ isAuthenticated }: any) {
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoute
